/**
 * Shipping Process — route switcher and document gallery.
 * What's Included is always visible; the active preview hydrates on init,
 * and the full-resolution image remains click-only in theme.js.
 */
document.addEventListener('DOMContentLoaded', function () {
  document.querySelectorAll('.ship').forEach(initShippingProcess);
});

function initShippingProcess(root) {
  var flowTabs = root.querySelectorAll('[data-flow-switch]');
  var flowPanels = root.querySelectorAll('[data-flow]');
  var routeContent = root.querySelectorAll('[data-route-content]');

  function selectRoute(tab) {
    var key = tab.getAttribute('data-flow-switch');

    flowTabs.forEach(function (item) {
      var isSelected = item === tab;
      item.classList.toggle('is-active', isSelected);
      item.setAttribute('aria-selected', isSelected ? 'true' : 'false');
    });

    flowPanels.forEach(function (panel) {
      var isSelected = panel.getAttribute('data-flow') === key;
      panel.classList.toggle('is-active', isSelected);
      panel.hidden = !isSelected;
    });

    routeContent.forEach(function (content) {
      var isSelected = content.getAttribute('data-route-content') === key;
      content.hidden = !isSelected;
      if (isSelected) {
        content.querySelectorAll('[data-docs-carousel]').forEach(initDocumentsCarousel);
      }
    });
  }

  flowTabs.forEach(function (tab) {
    tab.addEventListener('click', function () { selectRoute(tab); });
  });

  root.querySelectorAll('[data-docs-auto-init] [data-docs-carousel]').forEach(initDocumentsCarousel);
}

function hydrateDeferredImage(image) {
  if (!image || image.dataset.deferredLoaded === 'true') return;
  image.dataset.deferredLoaded = 'true';

  if (image.dataset.deferredSrcset) image.srcset = image.dataset.deferredSrcset;
  if (image.dataset.deferredSizes) image.sizes = image.dataset.deferredSizes;
  if (image.dataset.deferredSrc) image.src = image.dataset.deferredSrc;
}

function initDocumentsCarousel(carousel) {
  if (!carousel || carousel.dataset.docsBound === 'true') return;
  carousel.dataset.docsBound = 'true';

  var slides = carousel.querySelectorAll('[data-docs-slide]');
  var captions = carousel.querySelectorAll('[data-docs-caption]');
  var thumbs = carousel.querySelectorAll('[data-docs-thumb]');
  var prev = carousel.querySelector('[data-docs-prev]');
  var next = carousel.querySelector('[data-docs-next]');

  if (!slides.length) return;

  var index = 0;
  var count = slides.length;

  function loadMainImage(i) {
    var slide = slides[i];
    if (slide) hydrateDeferredImage(slide.querySelector('.ship__docs-image'));
  }

  function goTo(i) {
    index = (i + count) % count;
    loadMainImage(index);

    slides.forEach(function (slide, idx) {
      slide.classList.toggle('is-active', idx === index);
    });
    captions.forEach(function (caption, idx) {
      caption.classList.toggle('is-active', idx === index);
    });
    thumbs.forEach(function (thumb, idx) {
      thumb.classList.toggle('is-active', idx === index);
      if (idx === index) {
        thumb.setAttribute('aria-current', 'true');
        thumb.scrollIntoView({ behavior: 'smooth', block: 'nearest', inline: 'nearest' });
      } else {
        thumb.removeAttribute('aria-current');
      }
    });
  }

  // Stage 1: request only the small thumbnails when the gallery is activated.
  thumbs.forEach(function (thumb) {
    hydrateDeferredImage(thumb.querySelector('.ship__docs-thumb-image'));
  });

  // Stage 2: request only the currently selected main preview. Waiting for the
  // first thumbnail keeps it separate from the initial thumbnail batch.
  var firstThumb = thumbs[0] && thumbs[0].querySelector('.ship__docs-thumb-image');
  var loadInitialMain = function () { loadMainImage(0); };
  if (firstThumb && !firstThumb.complete) {
    firstThumb.addEventListener('load', loadInitialMain, { once: true });
    firstThumb.addEventListener('error', loadInitialMain, { once: true });
  } else {
    window.requestAnimationFrame(loadInitialMain);
  }

  if (prev) prev.addEventListener('click', function () { goTo(index - 1); });
  if (next) next.addEventListener('click', function () { goTo(index + 1); });

  thumbs.forEach(function (thumb, i) {
    thumb.addEventListener('click', function () { goTo(i); });
  });
}
